/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { ajax, Status, getState, arrayFrom, isEmpty} from '../../../twd/twd'
import useMarketNews from '../use-market-news'
import { getAuth } from '../use-bitvore'

const state = getState('corporates.use-search-company', {
    companies: []
})

export default () => {
    const {
        holdingCompany:selected,
        setHoldingCompany:setSelected,
    } = useMarketNews()
    const [status, setStatus] = React.useState(Status.LOADING)
    const [error, setError] = React.useState('')

    React.useEffect(() => {(async () => {
        try {
            setError('')
            setStatus(Status.LOADING)
            let {data} = await ajax({
                url: '/esb/retailservice/bitvoreNewsAPIService/getUserHoldingsList',
                method: 'POST',
                params: {
                    invTypes: ['C']
                }
            })

            let a = arrayFrom(await data)

            let rs = Object.values(a
                .filter(i => i.issue)
                .reduce( (x,i)=> {
                    let d = i.issue
                    if (!d || !(d.trim())) return x

                    let n = i.symbol
                    if (!x[n]) {
                        x[n] = { qty:0, symbol:n, label: d.trim() }
                    }

                    x[n].qty += i.qty
                    return x
                }, {}))
                .sort( (a,b) => b.qty - a.qty )
                .slice(0,10)
                .sort( (a,b) => {
                    if (b.label > a.label) return -1
                    if (b.label < a.label) return 1
                    return 0
                })

            await applyBitvoreIds(rs)

            state.set({ companies:rs })

            if (isEmpty(selected)) {
                setSelected(rs)
            }

            setStatus(Status.LOADED)
        } catch(e) {
            setStatus(Status.FAILED_TO_LOAD)
        }
    })()}, [])

    return {
        selected, setSelected,
        status, error,
    }
}

const applyBitvoreIds = async (rs) => {
    let tickers = rs.map( r => r.symbol ).filter(Boolean)
    if (tickers.length===0) return []

    let auth = await getAuth()
    let { data } = await ajax({
        url: 'https://api.bitvore.com/entityapi/entities',
        method: 'GET',
        headers: {
            ...auth
        },
        isDc: false,
        params: {
            ticker: tickers,
            pageSize: tickers.length * 2
        }
    })

    let a = await data
    arrayFrom(a.response).forEach(t => {
        let r = rs.find(r => r.symbol === t.ticker)
        if (!r) return
        if (!r.bitvoreId) r.bitvoreId = []
        r.bitvoreId.push(t.id)
    })

    return rs
}